export default "__VITE_ASSET__cEBmov2sfhKlkyg9TXv21Q__"